let Urls = {
  myWorks: "/api/v1/pennon_ted/my-works",
};
export { Urls };
